import React from 'react';
import classNames from 'classnames';
import './assigner-circle.scss';

interface Props {
	className: string;
	content: string | JSX.Element;
	description: string;
}

const Circle = ({ className, content, description }: Props) => {
	return (
		<div className="assigner-circle-container">
			<div className={classNames('assigner-circle', className)}>{content}</div>
			<span className="assigner-circle-description">{description}</span>
		</div>
	);
};

export default Circle;
